var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-bar',[_c('el-menu',{attrs:{"mode":"vertical","unique-opened":"","default-active":_vm.$route.path,"collapse":_vm.isCollapse,"background-color":"#304156","text-color":"#fff","active-text-color":"#409EFF"}},[_c('sidebar-item',{attrs:{"routes":_vm.permission_routers}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be0bed8c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Sidebar/index.vue
// module id = 2zn1
// module chunks = 329